"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggerName = void 0;
var loggerName = exports.loggerName = 'chime-sdk-events';